module.exports = __webpack_public_path__ + "media/packs/site/assets/images/fr/fr_section04_title-fc5a2753d35fda6c336c001255e80a1b.png";